import ThemedComponent from '../../hoc/ThemedComponent';

import { default as TicketsPageViewDefault } from './TicketsPage/View';
import { default as TicketsPageView3 } from '../../themes/3/pages/tickets/TicketsPage';
import { default as TicketsPageView4 } from '../../themes/4/pages/tickets/TicketsPage';

const ThemedTicketsPage = {
  default: TicketsPageViewDefault,
  // 3: TicketsPageView3,
  // 4: TicketsPageView4,
};

export const TicketsPageView = ThemedComponent(ThemedTicketsPage);
